import { render, staticRenderFns } from "./CreateTopping.vue?vue&type=template&id=99801c2a&"
import script from "./CreateTopping.vue?vue&type=script&lang=js&"
export * from "./CreateTopping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports